package org.lennycodes.hldi.pages.admin
import androidx.compose.runtime.*
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.style.KobwebComposeStyleSheet.invoke
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Color
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.navigation.BasePath.Companion.value
import com.varabyte.kobweb.silk.components.forms.Button
import com.varabyte.kobweb.silk.style.toAttrs
import com.varabyte.kobweb.silk.style.toModifier
import kotlinx.coroutines.await
import kotlinx.coroutines.launch
import org.jetbrains.compose.web.attributes.InputType
import org.jetbrains.compose.web.attributes.disabled
import org.jetbrains.compose.web.attributes.placeholder
import org.jetbrains.compose.web.attributes.selected
import org.jetbrains.compose.web.attributes.value
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.*
import org.lennycodes.hldi.backend.FirebaseService
import org.lennycodes.hldi.backend.collection
import org.lennycodes.hldi.backend.doc
import org.lennycodes.hldi.backend.setDoc
import org.lennycodes.hldi.data.GalleryImage
import org.w3c.dom.HTMLInputElement
import org.w3c.files.File


@Composable
fun AddToGalleryDialog(
    onDismiss: () -> Unit,
    onSuccess: () -> Unit
) {

    val scope = rememberCoroutineScope()

    var isLoading by remember {
        mutableStateOf(false)
    }

    var title by remember {
        mutableStateOf("")
    }

    var category by remember {
        mutableStateOf("")
    }

    var selectedFile by remember {
        mutableStateOf<File?>(null)
    }

    var errorMessage by remember {
        mutableStateOf("")
    }


    Div(
        attrs = Modifier
            .padding(16.px)
            .then(DialogBackdropStyle.toModifier())
            .toAttrs {

                onClick {
                    if (!isLoading) {
                        onDismiss()
                    }
                }

            }
    ) {


        Div(
            attrs = Modifier
                .padding(32.px)
                .then(DialogCardStyle.toModifier())
                .toAttrs {

                    onClick {
                        it.stopPropagation()
                    }

                }
        ) {


            H3(
                attrs = DialogTitleStyle.toAttrs()
            ) {

                Text("Add Gallery Image")

            }



            // Title

            Div(
                attrs = FieldGroupStyle.toAttrs()
            ) {

                Label(
                    attrs = FieldLabelStyle.toAttrs()
                ) {

                    Text("Title")

                }


                Input(
                    type = InputType.Text,
                    attrs = Modifier
                        .padding(11.px, 14.px)
                        .then(FieldInputStyle.toModifier())
                        .toAttrs {

                            placeholder(
                                "Image title"
                            )

                            value(title)

                            onInput {
                                title = it.value
                            }


                            if (isLoading) {
                                disabled()
                            }

                        }
                )

            }




            // Category

            Div(
                attrs = FieldGroupStyle.toAttrs()
            ) {

                Label(
                    attrs = FieldLabelStyle.toAttrs()
                ) {

                    Text("Category")

                }


                Select(
                    attrs = Modifier
                        .padding(11.px, 14.px)
                        .then(FieldInputStyle.toModifier())
                        .toAttrs {

                            onChange {
                                category = it.value.toString()
                            }

                            if (isLoading) {
                                disabled()
                            }
                        }
                ) {

                    Option(
                        value = "",
                        attrs = {
                            disabled()
                            if (category.isEmpty()) {
                                selected()
                            }
                        }
                    ) {
                        Text("Select category")
                    }


                    Option(
                        value = "Education",
                        attrs = {
                            if (category == "Education") {
                                selected()
                            }
                        }
                    ) {
                        Text("Education")
                    }


                    Option(
                        value = "Legal Aid",
                        attrs = {
                            if (category == "Legal Aid") {
                                selected()
                            }
                        }
                    ) {
                        Text("Legal Aid")
                    }


                    Option(
                        value = "Health",
                        attrs = {
                            if (category == "Health") {
                                selected()
                            }
                        }
                    ) {
                        Text("Health")
                    }


                    Option(
                        value = "Community Development",
                        attrs = {
                            if (category == "Community Development") {
                                selected()
                            }
                        }
                    ) {
                        Text("Community Development")
                    }

                }

            }





            // Image picker

            Div(
                attrs = FieldGroupStyle.toAttrs()
            ) {

                Label(
                    attrs = FieldLabelStyle.toAttrs()
                ) {

                    Text("Image")

                }


                Input(
                    type = InputType.File,
                    attrs = Modifier
                        .then(FieldInputStyle.toModifier())
                        .toAttrs {


                            attr(
                                "accept",
                                "image/*"
                            )


                            onChange {

                                val input =
                                    it.target


                                selectedFile =
                                    input.files?.item(0)

                            }


                            if (isLoading) {
                                disabled()
                            }

                        }
                )


                if (selectedFile != null) {

                    P(
                        attrs = Modifier
                            .fontSize(13.px)
                            .toAttrs()
                    ) {

                        Text(
                            selectedFile!!.name
                        )

                    }

                }

            }





            if (errorMessage.isNotEmpty()) {


                P(
                    attrs = Modifier
                        .color(
                            Color.rgb(
                                220,
                                53,
                                69
                            )
                        )
                        .fontSize(14.px)
                        .margin(
                            0.px,
                            0.px,
                            16.px
                        )
                        .toAttrs()
                ) {

                    Text(errorMessage)

                }

            }






            Row(
                modifier = DialogActionsRowStyle.toModifier(),
                horizontalArrangement = Arrangement.spacedBy(12.px)
            ) {



                Button(

                    enabled = !isLoading,

                    modifier = Modifier
                        .padding(
                            11.px,
                            22.px
                        )
                        .then(
                            CancelButtonStyle.toModifier()
                        ),

                    onClick = {
                        onDismiss()
                    }

                ) {

                    Text("Cancel")

                }






                Button(

                    enabled = !isLoading,

                    modifier = Modifier
                        .padding(
                            11.px,
                            22.px
                        )
                        .then(
                            SaveButtonStyle.toModifier()
                        ),


                    onClick = {


                        scope.launch {


                            errorMessage = ""


                            if (title.isBlank()) {

                                errorMessage =
                                    "Image title is required"

                                return@launch

                            }



                            if (category.isBlank()) {

                                errorMessage =
                                    "Image category is required"

                                return@launch

                            }



                            if (selectedFile == null) {

                                errorMessage =
                                    "Please select an image"

                                return@launch

                            }





                            try {


                                isLoading = true



                                val generatedId =
                                    generateFirebaseId()



                                val uploadedImage =
                                    uploadImage(
                                        selectedFile!!,
                                        generatedId
                                    )


                                val galleryImage =
                                    GalleryImage(
                                        id = generatedId,
                                        url = uploadedImage.url,
                                        title = title,
                                        category = category,
                                        storagePath = uploadedImage.storagePath
                                    )



                                val galleryCollection =
                                    collection(
                                        FirebaseService.db,
                                        "gallery"
                                    )



                                val imageDocument =
                                    doc(
                                        galleryCollection,
                                        generatedId
                                    )



                                setDoc(
                                    imageDocument,
                                    galleryImage.toFirebaseData()
                                ).await()



                                console.log(
                                    "Gallery image uploaded successfully"
                                )



                                onSuccess()
                                onDismiss()



                            } catch (e: Throwable) {


                                console.error(
                                    "Gallery upload failed: ${e.message}"
                                )


                                errorMessage =
                                    e.message
                                        ?: "Upload failed"



                            } finally {


                                isLoading = false


                            }


                        }


                    }

                ) {


                    Text(
                        if (isLoading)
                            "Uploading..."
                        else
                            "Upload"
                    )


                }


            }


        }


    }

}